import * as HttpService from "../../services/http.service";
import { SEND_TEAMS_ALERT_URL } from "../../services/url.service";
import { getCompanyId, getAuth } from "../../services/identity.service";

const reportedErrors = new Set();

export const reportFrontendError = async (service, errorMessage, error, context = {}) => {
  const companyId = context?.companyId || getCompanyId() || null;
  const userId = context?.userId || getAuth()?.id || null;

  const errorKey = `${service}-${errorMessage}`;
  if (reportedErrors.has(errorKey)) return;

  try {
    console.log("reporting frontend error");
    await HttpService.postWithAuth(SEND_TEAMS_ALERT_URL, {
      service,
      errorMessage,
      error: { status: error?.status, message: error?.message || errorMessage },
      companyId,
      userId,
      context,
    });
    reportedErrors.add(errorKey);
  } catch (err) {
    console.error(`Error reporting ${service} failure:`, err);
  }
};
